import React from 'react'
import '../App.css'

function Thanks() {
  return (
    <div className='thanks'>
    <h3>Thanks for Joining 😊</h3>
  </div>
  )
}

export default Thanks